import { Link } from "react-router-dom";
import { categories } from "@/data/articles";
import { TOPIC_HUBS } from "@/data/topic-hubs";

const SiteFooter = () => {
  return (
    <footer className="border-t border-divider bg-card mt-16">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
              src="/logo.png"
              alt="Global Energy Insider logo"
                width={28}
                height={28}
                className="w-7 h-7"
              />
              <span className="font-display text-lg font-bold text-foreground">
                Global Energy Insider
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Independent energy journalism delivering market insights, expert analysis, and price trends across global energy and commodities.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-foreground uppercase tracking-wider mb-4">
              Sections
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat.toLowerCase().replace(/ & /g, "-").replace(/ /g, "-")}`}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-foreground uppercase tracking-wider mb-4">
              Topics
            </h4>
            <ul className="space-y-2">
              {TOPIC_HUBS.map((hub) => (
                <li key={hub.slug}>
                  <Link
                    to={`/topic/${hub.slug}`}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {hub.headKeyword}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-foreground uppercase tracking-wider mb-4">
              About
            </h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">Editorial Team</Link></li>
              <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">Terms of Use</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-divider">
          <p className="text-xs text-muted-foreground leading-relaxed max-w-4xl">
            <strong>Disclaimer:</strong> Global Energy Insider is an independent journalist platform. The content reflects analysis and opinions of our journalists. It should not be construed as financial or investment advice. We publish diverse viewpoints, including opposing perspectives, to provide a complete picture of energy markets. All data and factual claims reference credible industry sources. Images generated for illustrative purposes are marked accordingly.
          </p>
          <p className="text-xs text-muted-foreground mt-4">
            © 2009 Global Energy Insider. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
